import React, { Component } from 'react';
import { connect } from 'react-redux';
import '../../css/modal.scss';
import image from '../../res/image';

class PhoneInputModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { isOpen, close } = this.props;
    return (
      <>
        {isOpen && this.props.posReducer.keyboardSetting ? (
          <>
            <div
              className={this.props.inline ? '' : 'Modal-overlay-empty'}
              onClick={close}
            />
            <div className={this.props.inline ? '' : 'Modal-empty desk'}>
              <div className="keyboard-container desk">
                <div
                  className="keyboard-set desk"
                  style={{ maxWidth: '320px' }}>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(1)}>
                    <div>1</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(2)}>
                    <div>2</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(3)}>
                    <div>3</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(0)}>
                    <div>0</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(4)}>
                    <div>4</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(5)}>
                    <div>5</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(6)}>
                    <div>6</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin('031')}>
                    <div>031</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(7)}>
                    <div>7</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(8)}>
                    <div>8</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(9)}>
                    <div>9</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin('010')}>
                    <div>010</div>
                  </div>
                </div>
                <div
                  className="keyboard-set desk"
                  style={{ maxWidth: '160px' }}>
                  <div
                    className="keyboard-gray"
                    onClick={() => this.props.backspace()}>
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={image.BackspaceIcon}
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    className="keyboard-gray"
                    onClick={() => this.props.reset()}>
                    <div>
                      <img
                        style={{ display: 'inline' }}
                        src={image.ResetIcon}
                        alt=""
                      />
                    </div>
                  </div>
                  <div
                    className="keyboard-blue-large"
                    onClick={() => this.props.ok()}>
                    <div>확인</div>
                  </div>
                </div>
              </div>
            </div>

            {/* 반응형 */}

            <div className={this.props.inline ? '' : 'Modal-empty pos'}>
              <div className="keyboard-container pos">
                <div className="keyboard-set pos" style={{ maxWidth: '200px' }}>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(1)}>
                    <div>1</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(2)}>
                    <div>2</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(3)}>
                    <div>3</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(0)}>
                    <div>0</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(4)}>
                    <div>4</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(5)}>
                    <div>5</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(6)}>
                    <div>6</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin('031')}>
                    <div>031</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(7)}>
                    <div>7</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(8)}>
                    <div>8</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin(9)}>
                    <div>9</div>
                  </div>
                  <div
                    className="keyboard-basic"
                    onClick={() => this.props.keyin('010')}>
                    <div>010</div>
                  </div>
                </div>
                <div className="keyboard-set pos" style={{ maxWidth: '100px' }}>
                  <div
                    className="keyboard-gray"
                    onClick={() => this.props.backspace()}>
                    <div>
                      <img
                        src={image.BackspaceIcon}
                        alt=""
                        style={{ width: 25, display: 'inline' }}
                      />
                    </div>
                  </div>
                  <div
                    className="keyboard-gray"
                    onClick={() => this.props.reset()}>
                    <div>
                      <img
                        src={image.ResetIcon}
                        alt=""
                        style={{ width: 25, display: 'inline' }}
                      />
                    </div>
                  </div>
                  <div
                    className="keyboard-blue-large"
                    onClick={() => this.props.ok()}>
                    <div>확인</div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : null}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { posReducer } = state;
  return { posReducer };
};
const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(PhoneInputModal);
